import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { parse, format } from "date-fns";
import dateFormat from "dateformat";
import dayjs from "dayjs";
import CustomDataGridDateHelper from "./DatePickerHelper";
import { _helper } from "../../GlobalFunction/dateHelper";
import { TextField } from "@mui/material";
import { useLanguageContext } from "../../../Context/LanguageContext";
function DateInputValue(props) {
  const { localization } = useLanguageContext();
  const { item, applyValue, focusElementRef } = props;
  const [value, setValue] = React.useState(
    item.value ? dayjs(item.value) : null
  );

  React.useImperativeHandle(focusElementRef, () => ({
    focus: () => {},
  }));

  const handleFilterChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      setValue(newValue);
      applyValue({ ...item, value: newValue.toISOString() }); // Ensure the value is ISO string
    } else {
      setValue(null);
      applyValue({ ...item, value: null }); // Handle null case
    }
  };

  return (
    <div id="muiFilterColumnDate">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Value"
          value={value}
          onChange={handleFilterChange}
          renderInput={(params) => <TextField {...params} variant="standard" />}
          inputFormat={_helper.DateFormateOrganization(true)}
          ref={focusElementRef}
        />
      </LocalizationProvider>
    </div>
  );
}

export function ColumneTypeDate(colName, headername, localization) {
  const dateCreatedOperators = [
    ...CustomDataGridDateHelper(DateInputValue, localization),
  ];

  return {
    field: colName,
    headerName: headername,
    width: 100,
    type: "date",
    flex: 1,

    filterOperators: dateCreatedOperators,
    renderCell: (params) => {
      if (params.value instanceof Date) {
        return (
          <span title={params.value} className="tableCellTextStyle">
            {format(params.value, _helper.DateFormateOrganization(true))}
          </span>
        );
      } else {
        return (
          <span title={params.value} className="tableCellTextStyle">
            {params.value}
          </span>
        );
      }
    },
    valueGetter: (params) => {
      if (params.value) {
        return parse(
          params.value,
          _helper.DateFormateOrganization(true),
          new Date()
        );
      }
      return null;
    },
    valueFormatter: (params) => {
      return params.value
        ? format(params.value, _helper.DateFormateOrganization(true))
        : "";
    },
  };
}
